import React from 'react';

import {
  ResizableHandle,
  ResizablePanel,
  ResizablePanelGroup,
} from '@/components/ui/resizable';
import { WorkspaceLayout } from '../../shared/components/Layout';
import ConversationSelector from './components/ConversationSelector';
import ConversationViewer from './components/ConversationViewer';
import { ConversationsProvider } from './context';

const Messenger = () => (
  <WorkspaceLayout>
    <ConversationsProvider>
      <ResizablePanelGroup className="rounded-lg border" direction="horizontal">
        <ResizablePanel defaultSize={30}>
          <ConversationSelector />
        </ResizablePanel>

        <ResizableHandle withHandle />

        <ResizablePanel defaultSize={70}>
          <ConversationViewer />
        </ResizablePanel>
      </ResizablePanelGroup>
    </ConversationsProvider>
  </WorkspaceLayout>
);

export default Messenger;
